import styled from 'styled-components';

interface ButtonProps {
  disabled?: boolean;
  plain: boolean;
  hovered: boolean;
}

interface ButtonContainerProps {
  plain: boolean;
  hovered: boolean;
  widthAuto?: boolean;
}

export default {
  Button: styled.button<ButtonProps>`
    display: block;
    padding: 8px;
    outline: none;
    border: 0;
    background: transparent;
    opacity: ${(props) => (props.disabled ? 0.5 : null)};

    &:hover > div {
      cursor: ${(props) => (props.disabled ? null : 'pointer')};
      box-shadow: ${(props) =>
        props.disabled || props.hovered ? null : '0px 14px 24px rgba(0, 0, 0, 0.05);'};
      background: ${(props) => (props.hovered ? '#f5f5f5' : null)};
    }
  `,

  Container: styled.div<ButtonContainerProps>`
    width: ${(props) => (props.widthAuto ? 'auto' : '35px')};
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    background: #fff;
    font-size: 30px;
    box-shadow: ${(props) => (props.plain ? null : '0px 3px 6px rgba(0, 0, 0, 0.16)')};
    border-radius: 8px;
    color: rgba(0, 0, 0, 0.64);
    font-weight: 200;
    transition: box-shadow 0.2s linear;
    box-sizing: border-box;
  `,
};
